import { useState, FC } from 'react';
import _times from 'lodash/times';
import { Props } from '@/components/tour/game/FinishScreen/components/StarRating/types';
import Icon from '@/units/Icon';

export const StarRating: FC<Props & { children?: any }> = ({ onChange, canEdit = true }) => {
  const [rating, setRating] = useState(0);

  const changeRating = (index: number) => {
    if (!canEdit) return;
    setRating(index);
    onChange(index);
  };

  return (
    <div className="d-flex justify-content-center">
      {_times(5, (index) => {
        const star = index + 1;
        return (
          <div onClick={() => changeRating(star)} key={star}>
            {star <= rating ? <Icon.StarSolid /> : <Icon.Star />}
          </div>
        );
      })}
    </div>
  );
};
